import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import Vuerify from 'vuerify'
import VuerifyDirective from 'v-vuerify-next'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import enLocale from 'element-ui/lib/locale/lang/en'    // 英语
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // 简体中文
import esLocale from 'element-ui/lib/locale/lang/es'   // 西班牙
import deLocale from 'element-ui/lib/locale/lang/de'   // 德语
import itLocale from 'element-ui/lib/locale/lang/it'   // 意大利
import poLocale from 'element-ui/lib/locale/lang/pt'   // 葡萄牙
import plLocale from 'element-ui/lib/locale/lang/pl'   // 波兰
import fiLocale from 'element-ui/lib/locale/lang/fi'   // 芬兰
import hkLocale from 'element-ui/lib/locale/lang/zh-TW'  // 繁体中文
import duLocale from 'element-ui/lib/locale/lang/nl'  // 荷兰
import frLocale from 'element-ui/lib/locale/lang/fr'  // 法语
import swLocale from 'element-ui/lib/locale/lang/sv-SE' // 瑞典
import czLocale from 'element-ui/lib/locale/lang/cz'    // 捷克
import dkLocale from 'element-ui/lib/locale/lang/da'    // 丹麦
import trLocale from 'element-ui/lib/locale/lang/tr-TR'    // 土耳其


import '../static/login.css'
import store from './auth/store'
import routes from './routes'

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuerify,{
  icode:{test:/^\d{6}$/,message:'请输入6位数字'},
  mobile:{test:/\d{1,}/,message:'Mobile must have 1 or more numbers'},
  realname:{test:/^[A-Za-z0-9][A-Za-z0-9\s]{2,18}[A-Za-z0-9]$/,message:'请输入正确姓名'},
  password:{test: /\S{6,20}/, message: '密码格式不对'},
  postcode:{test:/^\d{6}$/,message:'请输入6位数字'},
  height:{test:/^\d{2,}$/,message:'Height must have 2 or more numbers'},
  weight:{test:/^\d{2,}$/,message:'Weight must have 2 or more numbers'},
  email: { test: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/ , message: 'Please enter a valid Email.' },
});
Vue.use(VuerifyDirective);
Vue.use(VueI18n);
Vue.use(Vuex);


let hostname =window.location.hostname.split('.')[2];
let href =  window.location.href;
let lang='en';
let search = href.split('=')[1];
let country=['GB','CN','FR','DD','SE','AU','HKF','HU','IT','NL','Nor','PT','ES','TR','AE','Ro','CZ','SK','LT','PL','DK','FI'];
let languages = ['en','zh','fr','de','sw','en','hk','en','it','du','en','po','es','tr','en','en','cz','en','en','pl','dk','fi'];

if (1) {    // 正式版分支
  /*正式版缓存判断在后，测试版则相反*/
  if(!search){
    if(hostname==='cn'){
      lang='zh';
    }
    else{
      let langStore = localStorage.getItem('language');//判断是否有语言缓存
      if(!langStore){
        lang='en';
      }else{
        lang = langStore;
      }
    }
  }else{
    let index =0;
    country.map(function (e,i) {
      if(e===search){
        index = i;
      }
    });
    if(search==='DE'){
      index=3;
    }
    lang = languages[index];
  }

} else {
  let langStore = localStorage.getItem('language');//判断是否有语言缓存
  if(!langStore){
    if(!search){
      if(hostname==='cn'){
        lang='zh';
      }
      else{
        lang='en';
      }
    }else{
      let index =0;
      country.map(function (e,i) {
        if(e===search){
          index = i;
        }
      });
      if(search==='DE'){
        index=3;
      }
      lang = languages[index];
    }
  }else{
    lang = langStore;
  }
  console.log('lang:'+langStore+','+lang+','+search+','+hostname);
}

/**/
import {czMessages} from './lang/cz.js'
import {deMessages} from './lang/de.js'
import {dkMessages} from './lang/dk.js'
import {duMessages} from './lang/du.js'
import {enMessages} from './lang/en.js'
import {esMessages} from './lang/es.js'
import {fiMessages} from './lang/fi.js'
import {frMessages} from './lang/fr.js'
import {hkMessages} from './lang/hk.js'
import {itMessages} from './lang/it.js'
import {plMessages} from './lang/pl.js'
import {poMessages} from './lang/po.js'
import {swMessages} from './lang/sw.js'
import {trMessages} from './lang/tr.js'
import {zhMessages} from './lang/zh.js'


//import {enMessages} from './lang/en.js'
//import esMessages from './lang/es.js'


const i18n = new VueI18n({
   locale:lang,
  // locale: sessionStorage.getItem('language')||'en',
   messages:{
     //'en':Object.assign(require('./lang/en.json'),enLocale),
     /*
     'en':Object.assign(require('./lang/en.js'),enLocale),
     'zh':Object.assign(require('./lang/zh.js'),zhLocale),
     'es':Object.assign(require('./lang/es.js'),esLocale),
     //'es':Object.assign(require('./lang/json/es.json'),esLocale),
     'es':Object.assign(esMessages.esMessages, esLocale),
     'de':Object.assign(require('./lang/de.js'),deLocale),
     'it':Object.assign(require('./lang/it.js'),itLocale),
     'po':Object.assign(require('./lang/po.js'),poLocale),
     'hk':Object.assign(require('./lang/hk.js'),hkLocale),
     'du':Object.assign(require('./lang/du.js'),duLocale),
     'fr':Object.assign(require('./lang/fr.js'),frLocale),
     'sw':Object.assign(require('./lang/sw.js'),swLocale),
     'cz':Object.assign(require('./lang/cz.js'),czLocale),
     'pl':Object.assign(require('./lang/pl.js'),plLocale),
     'fi':Object.assign(require('./lang/fi.js'),fiLocale),
     'dk':Object.assign(require('./lang/dk.js'),dkLocale),
     'tr':Object.assign(require('./lang/tr.js'),trLocale),*/

     /*
     'cz':Object.assign(czMessages.czMessages, czLocale),
     'de':Object.assign(deMessages.deMessages, deLocale),
     'dk':Object.assign(dkMessages.dkMessages, dkLocale),
     'du':Object.assign(duMessages.duMessages, duLocale),
     'en':Object.assign(enMessages.enMessages, enLocale),
     'es':Object.assign(esMessages.esMessages, esLocale),
     'fi':Object.assign(fiMessages.fiMessages, fiLocale),
     'fr':Object.assign(frMessages.frMessages, frLocale),
     'hk':Object.assign(hkMessages.hkMessages, hkLocale),
     'it':Object.assign(itMessages.itMessages, itLocale),
     'pl':Object.assign(plMessages.plMessages, plLocale),
     'po':Object.assign(poMessages.poMessages, poLocale),
     'sw':Object.assign(swMessages.swMessages, swLocale),
     'tr':Object.assign(trMessages.trMessages, trLocale),
     'zh':Object.assign(zhMessages.zhMessages, zhLocale),*/

     /**/
     'cz':Object.assign(czMessages, czLocale),
     'de':Object.assign(deMessages, deLocale),
     'dk':Object.assign(dkMessages, dkLocale),
     'du':Object.assign(duMessages, duLocale),
     'en':Object.assign(enMessages, enLocale),
     'es':Object.assign(esMessages, esLocale),
     'fi':Object.assign(fiMessages, fiLocale),
     'fr':Object.assign(frMessages, frLocale),
     'hk':Object.assign(hkMessages, hkLocale),
     'it':Object.assign(itMessages, itLocale),
     'pl':Object.assign(plMessages, plLocale),
     'po':Object.assign(poMessages, poLocale),
     'sw':Object.assign(swMessages, swLocale),
     'tr':Object.assign(trMessages, trLocale),
     'zh':Object.assign(zhMessages, zhLocale)

     //'en':Object.assign(enMessages, enLocale),

   },
});
Vue.use(ElementUI,{
  i18n:(key,value) =>i18n.t(key,value)
});

const router = new VueRouter({
  //mode:'history',
  routes
});

 router.beforeEach((to,from,next)=>{
   if(!sessionStorage.getItem('token')){
      if(to.path!=='/login'&&to.path!=='/sign'&&to.path!=='/hcpSign'&&to.path!=='/hcpLogin' &&to.path!=='/updating'&&to.path!=='/error'
        && to.path!=='/updatePassword' && to.path!=='/personalApply' && to.path!=='/accountsmanagement'
        && to.path!=='/managementtools' && to.path!=='/verificationCode'
        // && to.path!=='/accountsadmin_super'
        // && to.path!=='/accountsadmin_super_add'
        // && to.path!=='/accountsadmin_home'
        // && to.path!=='/accountsadmin_list'
        // && to.path!=='/accountsadmin_add'
        && to.path!=='/clinic'){
         next({path:'/login'});
     } else {
       next();
     }
   }else{
     next();
   }
   //console.log(sessionStorage.getItem('token'));
 });

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

Vue.prototype.pushRequest = function (request) {
 // console.log(this);
  this.$store.commit('updateRequest',request);
};
Vue.http.interceptors.push((request, next) => {
  //console.log(this)//此处this为请求所在页面的Vue实例
 if(request.method === 'GET'){
   request.url +='?_='+new Date().getTime();
 }
  if(request.url === 'api/v2.0/monitor/data'){
    vm.pushRequest(request);
  }
 let timeout ;
 if(request._timeout){
   timeout = setTimeout(()=>{
     if(request.onTimeout){
       request.onTimeout(request);
       request.abort();
     }
   },request._timeout);
 }
  next((response) => {
   clearTimeout(timeout);
    return response;
  });
});




// WEBPACK FOOTER //
// ./src/main.js